import { Component, Input, OnInit } from '@angular/core';
import { Shape, Sizes, SkeletonSizeBase } from '../../../common';
import { getAvatarSizes, getSizes } from '../../../common/utils/utils';

@Component({
  selector: 'skc-linkedin-list',
  templateUrl: './linkedin-list.component.html',
  styleUrls: ['./linkedin-list.component.less']
})
export class LinkedinListComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-shape') shape = Shape.CIRCLE;
  @Input('skc-border-radius') borderRadius;
  @Input('skc-avatar-size') avatarSize: Sizes;
  @Input('skc-line-height') lineHeight;
  lHeight;
  size;
  constructor() {
    super();
  }

  ngOnInit() {
    this.size = getAvatarSizes(this.avatarSize);
    this.lHeight = getSizes(this.lineHeight);
  }
}
